import Container from "../Container";
import Text from "../Text";
import { useHomeContext } from "../../contexts/HomeContext";
import Currency from "../Currency";
import CardLoader from "../CardLoader";
import AssetsDoughnutChart from "../charts/AssetsDoughnutChart";
import Card from "../Card";
import Icon from "../Icon";
import { Tooltip } from "primereact/tooltip";

export default function CapitalGainChartCard() {
    const homeContext = useHomeContext();

    return (
        <Card>
            {
                homeContext.isLoading
                    ? (
                        <CardLoader />
                    )
                    : (
                        <>
                            <AssetsDoughnutChart />

                            <Container flexColumn center className="absolute gap-3 z-5">
                                <Container flexColumn center className="gap-1">
                                    <Tooltip 
                                        target=".mywallet-tooltip"
                                        content="Apresenta o valor atual da sua carteira com seus investimentos ativos." 
                                    />
                                    <Text color="900" fontWeight="medium" size="sm">Minha carteira <Icon name="pi-info-circle" className="mywallet-tooltip" size={2} /></Text>
                                    <Currency value={homeContext.wallet?.totalValue ?? 0}>
                                        {
                                            (value) => (
                                                <Text color="900" size="lg" fontWeight="semibold">{value}</Text>
                                            )
                                        }
                                    </Currency>
                                </Container>
                            </Container>
                        </>
                    )
            }
        </Card>
    )
}
